module.exports = __webpack_public_path__ + "static/img/bg-fr.82228873.png";